import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  Collapse,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  CardHeader,
} from '@cordata/buffet';

import IdentitySearchForm from '~/components/Patient/Identity/Search/Form';

const AdvancedSearchModal = ({
  isOpen,
  toggleIsOpen,
}) => {
  const [isCollapseOpen, setIsCollapseOpen] = useState(true);
  const [didSearch, setDidSearch] = useState(false);

  const [isResultsOpen, setIsResultsOpen] = useState(false);
  const [results, setResults] = useState([]);

  return (
    <Modal isOpen={isOpen} toggle={toggleIsOpen}>
      <ModalHeader toggle={toggleIsOpen}>Advanced search</ModalHeader>

      <ModalBody className="p-0">
        <Card body={false}>
          <CardHeader
            {...didSearch && {
              action: <Button outline size="sm" icon={isCollapseOpen ? 'chevron-up' : 'chevron-down'} onClick={() => setIsCollapseOpen(!isCollapseOpen)} />,
            }}
          >
            Search
          </CardHeader>

          <Collapse isOpen={isCollapseOpen} navbar>
            <IdentitySearchForm
              setDidSearch={setDidSearch}
              setResults={(r) => {
                setResults(r);

                setIsCollapseOpen(false);

                setIsResultsOpen(true);
              }}
            />
          </Collapse>
        </Card>

        {didSearch && (<>
          <Card body={false}>
            <CardHeader
              action={<Button outline size="sm" icon={isResultsOpen ? 'chevron-up' : 'chevron-down'} onClick={() => setIsResultsOpen(previous => !previous)} />}
            >
              Results
            </CardHeader>

            <Collapse isOpen={isResultsOpen} navbar>
              <ListGroup tag="div" flush>
                {results.length ? results.map(d => (
                  <ListGroupItem
                    key={d.id}
                    action
                    tag="a"
                    href={`/patients/${d.id}`}
                    className="d-flex justify-content-between align-items-center"
                  >
                    {d.attributes.lastName}{d.attributes.firstName && `, ${d.attributes.firstName}`}

                    <FontAwesomeIcon icon="chevron-right" className="text-muted" />
                  </ListGroupItem>
                )) : (
                  <ListGroupItem
                    className="d-flex justify-content-between align-items-center"
                  >
                    No results found.
                  </ListGroupItem>
                )}
              </ListGroup>
            </Collapse>
          </Card>
        </>)}
      </ModalBody>

      <ModalFooter>
        <Button color="tertiary" outline onClick={toggleIsOpen}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

AdvancedSearchModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleIsOpen: PropTypes.func.isRequired,
};

export default AdvancedSearchModal;
